import { CommonBonusDetails } from "../../models/responses/commonBonusDetails";
import localization from "../../../../config/localization";
import { formatUtcToLocalDateTime } from "../../../../utils/dateTimeHelper";
import { BonusConsts } from "../../models/constants/bonusConsts";
import { useState } from "react";
import { checkAndConsumeCashdrop } from "../../services/bonus.service";
import { Button } from "../../../../components/ui";
interface CashdropBonusCardProps {
  item: CommonBonusDetails;
  onClaimed?: () => void;
}
export default function CashdropBonus({
  item,
  onClaimed,
}: CashdropBonusCardProps) {
  const [isClaiming, setIsClaiming] = useState(false);

  const handleClaim = async () => {
    if (isClaiming) return;
    setIsClaiming(true);
    try {
      const success = await checkAndConsumeCashdrop(
        item.bonusid,
        item.bonuswallettransactionid,
      );
      if (success && onClaimed) {
        onClaimed();
      }
    } finally {
      await new Promise((r) => setTimeout(r, 1300));
      setIsClaiming(false);
    }
  };

  return (
    <div className="w-full bg-[#010101] border border-[#353535] rounded-[4px] p-3">
      <div className="grid gap-3 text-white">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <img
              src="/icons/Bonus/ic-cashdrop.svg"
              alt="Cashdrop"
              className="size-6"
            />
            <span className="font-medium text-sm text-[#ECECFF]">
              {localization.cashdrop_bonus}
            </span>
          </div>
          {item.status === BonusConsts.ActiveStatus && (
            <Button
              onClick={handleClaim}
              disabled={isClaiming}
              style={{
                background: "linear-gradient(180deg, #650687 0%, #4C0067 100%)",
              }}
              className="text-white text-sm font-medium px-4 py-1 rounded"
            >
              {localization.claim}
            </Button>
          )}
          {item.status === BonusConsts.ConsumedStatus && (
            <span className="bg-gradient-to-r from-[#010101] via-[#003D13] to-[#010101] p-1.5">
              <span className="text-[#00FE4D] text-xs font-medium">
                {item.status}
              </span>
            </span>
          )}
        </div>

        {item.verticalbonusname && (
          <div className="flex flex-wrap gap-1.5">
            {item.verticalbonusname.split(",").map((tag, index) => {
              const name = tag.trim().toLowerCase();
              let icon = "";
              let label = tag.trim();

              if (name.includes(BonusConsts.ExchangeVertical.toLowerCase())) {
                icon = "/icons/Bonus/ic-bonus-exchange-vertical.svg";
              } else if (
                name.includes(BonusConsts.CasinoVertical.toLowerCase())
              ) {
                icon = "/icons/Bonus/ic-bonus-casino-vertical.svg";
              } else if (
                name.includes(BonusConsts.SportsVertical.toLowerCase())
              ) {
                icon = "/icons/Bonus/ic-bonus-sports-vertical.svg";
              }

              return icon ? (
                <span
                  key={index}
                  className="inline-flex items-center gap-1.5 bg-[#1A1A1A] border border-[#353535] rounded-lg px-2.5 py-1"
                >
                  <img src={icon} alt={label} className="size-4" />
                  <span className="text-xs text-white">
                    {localization.getString(name)}
                  </span>
                </span>
              ) : null;
            })}
          </div>
        )}
        <div className="font-medium text-lg">{item.bonusname}</div>
        <div className="flex justify-between items-end">
          <div>
            <span className="text-base font-medium">
              {`${item.bonusamount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}₹`}
            </span>{" "}
            <p className="text-sm font-medium text-[#A9A9A9]">
              {localization.total_bonus_amount}
            </p>
          </div>
          <div className="text-right">
            <span className="text-base font-medium">
              {item.status?.toLowerCase() === BonusConsts.CancelledStatus
                ? formatUtcToLocalDateTime(item.modified, false)
                : formatUtcToLocalDateTime(item.bonusexpiredate, false)}
            </span>
            <p className="text-sm font-medium text-[#A9A9A9] text-left">
              {item.status === BonusConsts.CancelledStatus
                ? localization.bonuscanceldate
                : item.status === BonusConsts.ConsumedStatus
                  ? localization.bonusexpiringdate
                  : localization.bonusexpireddate}
            </p>
          </div>
        </div>
        {(item.status === BonusConsts.ExpiredStatus ||
          item.status === BonusConsts.ConsumedStatus) && (
          <div>
            <span className="text-base font-medium">
              {item.claimingdate
                ? formatUtcToLocalDateTime(item.claimingdate, false)
                : "-"}
            </span>
            <p className="text-sm font-medium text-[#A9A9A9]">
              {item.status === BonusConsts.ExpiredStatus
                ? localization.bonus_claiming_date
                : localization.bonusconsumeddate}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
